import * as React from 'react';
import logo from '../../../images/logo.svg';
import { Navigate } from 'react-router-dom';

const baseUrl = process.env.REACT_APP_BASE_URL || 'https://app-api.spinndo.com/api';

export default function Verify() {
  const [email, setEmail] = React.useState('');
  const [code, setCode] = React.useState('');
  const [error, setError] = React.useState('');
  const [success, setSuccess] = React.useState('');
  const [verified, setVerified] = React.useState(false);

  const handleVerify = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email || !email.includes('@')) {
      setError('يرجى إدخال بريد إلكتروني صالح.');
      return;
    }

    if (!code || code.length < 4) {
      setError('الرجاء إدخال رمز التفعيل بشكل صحيح.');
      return;
    }

    try {
      const response = await fetch(`${baseUrl}/activateCode`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',
                  'Accept-Language': 'en',

         },
        body: JSON.stringify({ email, code })
      });

      const result = await response.json();

      if (response.ok && result.status === 'success') {
        setSuccess('تم التحقق من بريدك بنجاح.');
        setVerified(true);
      } else {
        setError(result.message || 'رمز التفعيل غير صحيح.');
      }
    } catch (err: any) {
      setError('خطأ في الاتصال بالخادم.');
    }
  };

  if (verified) return <Navigate to="/" replace />;

  return (
    <div className="flex flex-col items-center justify-center px-6 pt-8 mx-auto md:h-screen dark:bg-gray-900">
      <img src={logo} className="mr-4 h-11" alt="Logo" />
      <span className="text-white text-lg mb-4">تفعيل البريد الإلكتروني</span>

      <div className="w-full max-w-md p-6 space-y-6 bg-white rounded-lg shadow dark:bg-gray-800">
        <form onSubmit={handleVerify}>
          <div>
            <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
              البريد الإلكتروني
            </label>
            <input
              type="email"
              name="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full p-2.5 rounded-lg border border-gray-300 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              placeholder="example@email.com"
            />
          </div>

          <div>
            <label htmlFor="code" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
              رمز التفعيل
            </label>
            <input
              type="text"
              name="code"
              id="code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
              className="w-full p-2.5 rounded-lg border border-gray-300 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              placeholder="أدخل الرمز المرسل إلى بريدك"
            />
          </div>

          <button
            type="submit"
            className="mt-4 w-full px-5 py-3 text-white bg-primary-700 rounded-lg hover:bg-primary-800"
          >
            تحقق
          </button>

          {error && <div className="text-red-500 text-sm mt-2">{error}</div>}
          {success && <div className="text-green-500 text-sm mt-2">{success}</div>}
        </form>
      </div>
    </div>
  );
}
